'use strict';

var _createForOfIteratorHelper = require("C:\\data\\one-vote\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");
var shuffle = require('shuffle-array');
var roundTo = require('round-to');
var round = function round(n) {
  return roundTo(n, 12);
};
var sum = function sum(votes) {
  var res = 0;
  for (var key in votes) res += votes[key];
  return res;
};
var calculateShares = function calculateShares(votes, seats) {
  var allVotes = sum(votes);
  var shares = {};
  for (var party in votes) {
    shares[party] = round(votes[party] * seats / allVotes);
  }
  return shares;
};
var collectRemainders = function collectRemainders(shares) {
  var remainders = [];
  for (var party in shares) {
    remainders.push(round(shares[party] - Math.floor(shares[party])));
  }
  remainders.sort();
  remainders.reverse();
  return remainders;
};
var partiesByRemainder = function partiesByRemainder(remainder, shares) {
  var parties = [];
  for (var party in shares) {
    if (round(shares[party] - Math.floor(shares[party])) == remainder) parties.push(party);
  }
  return parties;
};
var roundShares = function roundShares(shares, seats) {
  // calculate minimum seats per party
  var parliament = {};
  for (var party in shares) {
    parliament[party] = Math.floor(shares[party]);
  }

  // distribute remaining seats
  var remainingSeats = seats - sum(parliament);
  if (remainingSeats > 0) {
    var remainders = collectRemainders(shares);
    var parties;
    var doneRemainders = [];
    var _iterator = _createForOfIteratorHelper(remainders),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var remainder = _step.value;
        parties = partiesByRemainder(remainder, shares);
        if (remainder > remainders[remainingSeats] && doneRemainders.indexOf(remainder) < 0) {
          var _iterator2 = _createForOfIteratorHelper(parties),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _party = _step2.value;
              parliament[_party] += 1;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        if (remainder == remainders[remainingSeats - 1] && remainder == remainders[remainingSeats] && doneRemainders.indexOf(remainder) < 0) {
          var _iterator3 = _createForOfIteratorHelper(parties),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _party2 = _step3.value;
              parliament[_party2] = shares[_party2];
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
        doneRemainders.push(remainder);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return parliament;
};
var distribute = function distribute(votes, seats) {
  var draw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var shares = calculateShares(votes, seats);
  var parliament = roundShares(shares, seats);
  if (draw) {
    var parties = [];
    for (var party in parliament) {
      if (parliament[party] - Math.floor(parliament[party]) != 0) parties.push(party);
      parliament[party] = Math.floor(parliament[party]);
    }
    shuffle(parties);
    for (var i = 0; i < seats - sum(parliament); i++) {
      parliament[parties[i]] += 1;
    }
  }
  return parliament;
};
module.exports = distribute;